import { get, set } from "firebase/database";
import React, { useContext, useEffect, useState } from "react";
import { fbAuth } from "../../firebase";
import { refUser } from "../../models/user";
import { logSignUp } from "../../models/analytics";

const initialAuthState: [string | null, boolean, any] = [null, true, null];
export const AuthContext = React.createContext<[string | null, boolean, any]>(initialAuthState);
export const useAuthContext = () => useContext(AuthContext)

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [[uid, initializing, error], setAuthState] = useState<[string | null, boolean, any]>(initialAuthState);

  useEffect(() => {
    fbAuth.onAuthStateChanged(async (user) => {
      if (user?.uid) {
        const userRef = refUser(user.uid)
        const userSnapshot = await get(refUser(user.uid))

        // Create user if one doesn't exist
        if (!userSnapshot.exists()) {
          await set(userRef, { name: user.displayName ?? "Anonymous" })
          const providerId = user.providerData[0]?.providerId;
          const method: "google" | "password" | "anonymous" =
            providerId === "google.com" ? "google" :
            providerId === "password" ? "password" :
            "anonymous";
          logSignUp(method);
        }

        setAuthState([user.uid, false, null]);
      } else {
        setAuthState([null, false, null]);
      }
    }, (err) => setAuthState([null, false, err]))
  }, []);

  return (
    <AuthContext.Provider value={[uid, initializing, error]}>
      {initializing ? <div /> : children}
    </ AuthContext.Provider>
  );
};